export default "__VITE_ASSET__CHa9rY1f__"